/**
 * @ngdoc directive
 * @name article
 *
 * @description
 * Single article layout
 */
module.directive('article', function () {
    'use strict';
    return {
        restrict: 'E',
        replace: true,
        scope: {
            labelmore: '@',
            showdate: '@?',
            article: '=content',
            theme: '=?'
        },
        controller: ['$scope', '$filter', function ($scope, $filter) {
            if (!$scope.article.state) {
                $scope.article.state = 'section({id: \'' + $scope.article.field_identifier + '\'})';
            }
        }],
        template:
                '      <div class="aqua-article">' +
                '        <div class="aqua-article--picture grid-12-s">' +
                '          <a ui-sref="{{article.state}}"><img class="aqua-article--image" aqua-src="{{article.field_image.src}}" alt="{{article.field_image.alt}}" /></a>' +
                '        </div>' +
                '        <div class="aqua-article--description grid-12-s grid grid-v">' +
                '          <h3 class="aqua-article--title"><a ui-sref="{{article.state}}" ng-style="{\'color\': theme.color_subtitle}">{{article.title}}</a></h3>' +
                '          <p ng-if="showdate === \'true\'" class="aqua-article--date" ng-style="{\'color\': theme.color_lighttext}">{{article.created | date:\'dd/MM/yyyy\'}}</p>' +
                '          <p class="aqua-article--chapo" ng-style="{\'color\': theme.color_text}">{{article.field_teaser}}</p>' +
                '          <p class="aqua-article--more"><a class="aqua-article--more--link" ui-sref="{{article.state}}" ng-style="{\'color\': theme.color_link}">{{labelmore}}</a></p>' +
                '        </div>' +
                '      </div>'
    };
});